import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../../../assets/images/logo.png";
import { getApiUrl } from "../../helpers/Util";
import projectServices from "../../project/services/projectServices";
import { setLoginUserData } from "../../project/redux/projectAction";

const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    /**
     * ============================
     * Redux State
     * ============================
     */
    const loginUserData = useSelector((state) => state.loginUserData);

    /**
     * ============================
     * Local State
     * ============================
     */
    const [userName, setUserName] = useState("");
    const [profileImage, setProfileImage] = useState(null);
    const [isShow, setIsShow] = useState("hide");

    /**
     * ============================
     * componentDidMount
     * ============================
     */
    useEffect(() => {
        const storedUserName = localStorage.getItem("userName");
        const storedProfileImage = localStorage.getItem("profileImage");

        const image =
            !storedProfileImage || storedProfileImage === "undefined"
                ? "/assets/images/profile-pic.jpeg"
                : storedProfileImage;

        setUserName(storedUserName || "");
        setProfileImage(image);
    }, []);

    /**
     * ============================
     * Fetch Logged-in User Details
     * ============================
     */
    const getLoginUserData = useCallback(() => {
        const loginUserDataClone = { ...loginUserData };

        projectServices
            .getUserDetailByToken()
            .then((res) => {
                if (res.data?.status) {
                    const result = res.data.data;
                    dispatch(
                        setLoginUserData({
                            ...loginUserDataClone,
                            userName: result.profile.name,
                            profileImage: result.profile.profileImage,
                            roleKey: result.profile.roleKey,
                        })
                    );
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }, [dispatch, loginUserData]);

    /**
     * ============================
     * Logout Handler
     * ============================
     */
    const handleLogout = useCallback(() => {
        const loginUserDataClone = { ...loginUserData };

        dispatch(
            setLoginUserData({
                ...loginUserDataClone,
                userName: "",
                profileImage: "",
                roleKey: "",
            })
        );

        localStorage.clear();
        navigate("/login");
    }, [dispatch, loginUserData, navigate]);

    /**
     * ============================
     * UI Handlers
     * ============================
     */
    const showLogout = useCallback(() => {
        // intentionally left unchanged (same behavior as class)
        // setIsShow(isShow === "hide" ? "show" : "hide");
    }, []);

    /**
     * ============================
     * Render
     * ============================
     */
    return (
        <header id="page-topbar">
            <div className="navbar-header">
                <div className="d-flex">
                    {/* Menu Button */}
                    <button
                        type="button"
                        className="btn btn-sm px-3 font-size-20 header-item waves-effect vertical-menu-btn navbar-toggler"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarToggle"
                        aria-controls="navbarToggle"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <i className="uil uil-bars"></i>
                    </button>

                    {/* Logo */}
                    <div className="navbar-brand-box">
                        <Link to="/" className="logo logo-dark">
                            <span className="logo-sm">
                                <img src={Logo} alt="Logo" style={{ height: '40px', objectFit: 'contain' }} />
                            </span>
                        </Link>
                    </div>
                </div>

                {/* User Dropdown */}
                <div className="d-flex">
                    <div className="dropdown d-inline-block">
                        <button
                            type="button"
                            className="btn header-item waves-effect"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            onClick={showLogout}
                        >
                            <img
                                className="rounded-circle header-profile-user"
                                src={loginUserData.profileImage || profileImage}
                                alt="Header Avatar"
                                onError={(event) => {
                                    event.target.src = "/assets/images/profile-pic.jpeg";
                                    event.onerror = null;
                                }}
                            />
                            <span className="d-none d-xl-inline-block ms-1 fw-medium font-size-15">
                                {loginUserData.userName || userName}
                            </span>
                            <i className="uil-angle-down d-none d-xl-inline-block font-size-15"></i>
                        </button>

                        <div className="dropdown-menu dropdown-menu-end">
                            <Link className="dropdown-item" to="/userprofile">
                                <i className="uil uil-user-circle font-size-18 align-middle text-muted me-1"></i>
                                <span className="align-middle text-dark">
                                    View Profile
                                </span>
                            </Link>

                            <Link className="dropdown-item" to="/changepassword">
                                <i className="uil uil-lock-alt font-size-18 align-middle text-muted me-1"></i>
                                <span className="align-middle text-dark">
                                    Change Password
                                </span>
                            </Link>

                            <button
                                type="button"
                                className="dropdown-item"
                                onClick={handleLogout}
                            >
                                <i className="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted"></i>
                                <span className="align-middle">Sign out</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
